/* global ga */

import Cookies from 'js-cookie';

function updateDatalayer(level) {
    const layer = window.dataLayer ?? [];

    // send an event with the newly selected level
    layer.push({
        'event': 'select_cookie_consent',
        'cookie_consent': level
    });

    // update values (modern and legacy) in place
    layer[0].cookie_consent = level;
    layer[0].cookieConsent = level; // for compatibility
}

export default function initCookieConsent() {
    const consent_forms = document.querySelectorAll('.cookie-consent-form');

    let target_domain = consent_forms[0]?.dataset.cookieDomain;
    // temporary peppered.org check because we don't have a good env file for the review env
    if (!target_domain || window.location.hostname.includes('peppered.org')) {
        target_domain = window.location.hostname;
    }

    // Self repair if cookie_consent has been set on an erroneous domain.
    if (consent_forms.length > 0 && target_domain !== window.location.hostname) {
        Cookies.remove('cookie_consent', { domain: window.location.hostname, path: '/' });
        Cookies.remove('cookie_consent_last_updated', { domain: window.location.hostname, path: '/' });
    }

    function setCookie(level) {
        if (!level) {
            Cookies.remove('cookie_consent', { domain: target_domain });
            return;
        }

        Cookies.set('cookie_consent', level, {
            expires: 365,
            domain: target_domain
        });
    }

    function setConsent(level) {
        const tagmanager_placeholder = document.getElementById('tagmanager-placeholder');

        if (! level) {
            return;
        }

        setCookie(level);
        updateDatalayer(level);

        Cookies.set('cookie_consent_last_updated', new Date().toISOString(), {
            expires: 365,
            domain: target_domain
        });

        consent_forms.forEach(function(form) {
            form.classList.add('cookie-consent-form--waiting');
        });

        if (level !== 'default' && tagmanager_placeholder) {
            /*
                dynamically add the tagmanager code snippet
                this allows analytics etc to catch the initial visit and
                record information like the referrer
                this loads the tagmanager with the cookie consent correctly set
                we also reload to rebuild things like iframes and video embeds
            */

            tagmanager_placeholder.innerHTML = tagmanager_placeholder.dataset.snippet;

            // if analytics loads really fast we're ready to reload asap
            window.setTimeout(function() {
                if (window.ga && ga.loaded) {
                    window.location.reload();
                }
            }, 500);
            // otherwise we give it a second extra and reload anyway
            window.setTimeout(function() {
                window.location.reload();
            }, 1500);

        } else {
            window.location.reload();
        }
    }

    consent_forms.forEach(function(form) {
        const options_form = form.querySelector('[name="cookieConsentOptions"]');
        const all_the_cookies_button = form.querySelector('button[name="all"]');

        if (all_the_cookies_button) {
            all_the_cookies_button.onclick = function(event) {
                event.preventDefault();
                event.stopPropagation();
                setConsent('all');
            };
        }

        form.querySelectorAll('button[name="settings"]').forEach(function(button) {
            button.onclick = function(event) {
                event.preventDefault();
                event.stopPropagation();
                form.classList.toggle('settings');
            };
        });

        form.querySelectorAll('button[type="button"][value]').forEach(function(button) {
            button.onclick = function(event) {
                event.preventDefault();
                event.stopPropagation();
                setConsent(button.value);
            };
        });

        if (options_form) {
            options_form.onsubmit = function(event) {
                event.preventDefault();
                event.stopPropagation();
                setConsent(options_form.elements.cookieConsentLevel.value);
            };
        }
    });

    // lengthen cookie expiration date every time someone visits the site
    if (Cookies.get('cookie_consent')) {
        setCookie(Cookies.get('cookie_consent'));
    }

    document.querySelectorAll('button[name="reset_cookie_consent"]').forEach((button) => {
        button.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            setCookie(null);
            updateDatalayer(null);
            window.location.reload();
        };
    });
}
